<template>
    <div class="row" v-if="records && records.length > 0">
        <div class="col-lg-12">
            <div class="col-lg-8">
                <small class="font-weight-bold">
                    Showing {{ pagination.from == 0 ? 1 : pagination.from }} - {{ pagination.to }} of
                    {{ pagination.total }} entries
                </small>
            </div>
            <div class="card shadow">

                <div class="table-responsive">
                    <base-table
                        class="table align-items-center table-flush"
                        thead-classes="thead-light"
                        tbody-classes="list"
                        :data="records"
                    >
                        <template slot="columns">
                            <th width="2%">S/N</th>
                            <th width="10%">Candidate</th>
                            <th width="10%">Payment Ref</th>
                            <th width="10%">Email Address</th>
                            <th width="10%">{{ title }}</th>                            
                            <th width="5%">&nbsp;</th>
                        </template>

                        <template
                            slot-scope="{row, index}"
                        >
                        <td class="budget">
                            {{ pagination.from+index}}
                        </td>
                        <td class="text-capitalize">
                            {{ row.personal_data && row.personal_data.full_name ? row.personal_data.full_name  : 'N/A' }}
                        </td>
                        <td>
                            {{ row.ref ? row.ref : 'N/A' }}
                        </td>
                        <td>
                            {{ row.personal_data && row.personal_data.email ? row.personal_data.email  : 'N/A' }}
                        </td>
                        <td>
                            {{ getExactDate(row) | getDateFormat }}
                        </td>
                        <td>
                            <router-link
                                :to="'/remediation/details-'+row.access_token"
                                :disabled="(privileges && privileges.view == 'no') || ! privileges"
                                tag="button"
                                class="btn btn-sm btn-success"
                            >
                                <i class="fa fa-eye"></i> Details
                            </router-link>
                        </td>

                        </template>

                    </base-table>
                </div>

                <div
                    class="card-footer d-flex justify-content-end bg-transparent"
                    v-if="hasPagination"
                     @click="paginate"
                >
                    <base-pagination
                        :total="pagination.total"
                        align="center"
                        v-model="pagination.number"
                        :perPage="pagination.perPage"

                    >
                    </base-pagination>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';

    export default {
        name: 'PendingApplicationData',
        props: ["records", "pagination", "hasPagination", "paginate", "privileges", "title",
            "paginatedItems", "code"],
        filters: {
            getDateFormat(value) {
                return value ? moment(value).format('Do MMM, YYYY') : 'N/A';
            }
        },
        methods: {
            getExactDate(data) {// get exact date for the application
                if(data && (data.status == 'pending')) {
                    return data.application_date;
                } else {
                    return data.approved_date ? data.approved_date : data.application_date;
                }
            }
        },
    }
</script>